import { Converter } from '../types/converter';

export const thermalResistanceConverter: Converter = {
  id: 'thermalResistance',
  name: 'Thermal Resistance Converter',
  icon: 'Thermometer',
  categories: ['engineering', 'heat'],
  units: [
    // Base unit
    { name: 'Kelvin/Watt', symbol: 'K/W', factor: 1 },
    
    // Fahrenheit-based units
    { name: 'Degree Fahrenheit Hour/Btu (IT)', symbol: '°F·h/Btu (IT)', factor: 0.527760278 },
    { name: 'Degree Fahrenheit Hour/Btu (th)', symbol: '°F·h/Btu (th)', factor: 0.528434999 },
    { name: 'Degree Fahrenheit Second/Btu (IT)', symbol: '°F·s/Btu (IT)', factor: 0.000146600077 },
    { name: 'Degree Fahrenheit Second/Btu (th)', symbol: '°F·s/Btu (th)', factor: 0.000146787499 }
  ]
};
